<div class="add-person-contact__header">
  <h2 mat-dialog-title class="add-person-contact__title">Add Person Contact</h2>
  <button type="button" class="add-person-contact__close" mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="add-person-contact">
  <p class="add-person-contact__eyebrow">Search for a user</p>
  <p class="add-person-contact__description">
    Person contacts stay in sync with the linked user account — name, email, phone, and photo follow the user.
  </p>
  <div class="add-person-contact__search">
    <mat-icon class="add-person-contact__search-icon">search</mat-icon>
    <input class="add-person-contact__search-input" placeholder="Name or email..." [formControl]="searchControl" />
  </div>

  <div class="add-person-contact__results">
    @if (loading) {
      <div class="add-person-contact__message">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    } @else if (hasError) {
      <p class="add-person-contact__message">Could not load users. Please try again.</p>
    } @else if (filteredUsers$ | async; as users) {
      @if (users.length) {
        <cdk-virtual-scroll-viewport [itemSize]="rowHeight" class="add-person-contact__viewport">
          <button
            type="button"
            *cdkVirtualFor="let user of users; trackBy: trackById"
            class="add-person-contact__row"
            [class.add-person-contact__row--selected]="selectedUser?.id === user.id"
            (click)="select(user)">
            <span class="add-person-contact__avatar">{{ getInitials(user.name) }}</span>
            <span class="add-person-contact__row-text">
              <span class="add-person-contact__row-name">{{ user.name }}</span>
              <span class="add-person-contact__row-email">{{ user.email }}</span>
            </span>
            @if (selectedUser?.id === user.id) {
              <mat-icon class="add-person-contact__row-check">check</mat-icon>
            }
          </button>
        </cdk-virtual-scroll-viewport>
      } @else {
        <p class="add-person-contact__message">No users found.</p>
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="add-person-contact__actions">
  <button type="button" class="add-person-contact__button add-person-contact__button--cancel" mat-dialog-close>
    Cancel
  </button>
  <button
    type="button"
    class="add-person-contact__button add-person-contact__button--primary"
    [disabled]="!selectedUser || saving"
    (click)="save()">
    {{ saving ? 'Adding...' : 'Add contact' }}
    <span class="sgl-arrows" aria-hidden="true"></span>
  </button>
</mat-dialog-actions>
